import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import './CoursesPage.css';

const CoursesPage = () => {
  const { theme } = useTheme();
  const [activeTab, setActiveTab] = useState('11-12');
  const [expandedCourse, setExpandedCourse] = useState(null);

  const courses = {
    '11-12': [
      {
        id: 1,
        subject: 'Medical Stream',
        icon: '🧬',
        subjects: ['Biology', 'Chemistry', 'Physics'],
        isStream: true
      },
      {
        id: 2,
        subject: 'Non-Medical Stream',
        icon: '⚛️',
        subjects: ['Mathematics', 'Physics', 'Chemistry'],
        isStream: true
      },
      {
        id: 3,
        subject: 'Commerce Stream',
        icon: '📊',
        subjects: [ 'Mathematics'],
        isStream: true
      }
    ],
    '9-10': [
      {
        id: 4,
        subject: 'Mathematics',
        icon: '🧮',
        isStream: false
      },
      {
        id: 5,
        subject: 'Science',
        icon: '🔬',
        isStream: false
      },
      {
        id: 6,
        subject: 'English',
        icon: '📖',
        isStream: false
      },
      {
        id: 7,
        subject: 'Social Science',
        icon: '🌍',
        isStream: false
      }
    ],
    '8': [
      {
        id: 8,
        subject: 'Mathematics',
        icon: '📐',
        isStream: false
      },
      {
        id: 9,
        subject: 'Science',
        icon: '⚗️',
        isStream: false
      },
      {
        id: 10,
        subject: 'English',
        icon: '✍️',
        isStream: false
      },
      {
        id: 11,
        subject: 'Social Studies',
        icon: '🗺️',
        isStream: false
      }
    ]
  };

  const handleCourseClick = (courseId, isStream) => {
    if (isStream) {
      setExpandedCourse(expandedCourse === courseId ? null : courseId);
    }
  };

  return (
    <div className="courses-page" data-theme={theme}>
      <section className="courses-header">
        <h1 className="gradient-text">Our Courses</h1>
        <p className="subtitle">Comprehensive programs designed for academic excellence</p>
        
        <div className="grade-tabs">
          <button 
            className={`tab-button ${activeTab === '11-12' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('11-12');
              setExpandedCourse(null);
            }}
          >
            Class 11-12
          </button>
          <button 
            className={`tab-button ${activeTab === '9-10' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('9-10');
              setExpandedCourse(null);
            }}
          >
            Class 9-10
          </button>
          <button 
            className={`tab-button ${activeTab === '8' ? 'active' : ''}`}
            onClick={() => {
              setActiveTab('8');
              setExpandedCourse(null);
            }}
          >
            Class 8
          </button>
        </div>
      </section>

      <section className="course-cards">
        {courses[activeTab].map(course => (
          <div 
            key={course.id} 
            className={`course-card ${course.isStream ? 'stream-course' : ''} ${expandedCourse === course.id ? 'expanded' : ''}`}
            onClick={() => handleCourseClick(course.id, course.isStream)}
          >
            <div className="card-content">
              <div className="subject-icon">{course.icon}</div>
              <h3>{course.subject}</h3>
              
              {course.isStream && expandedCourse === course.id && (
                <div className="subjects-details">
                  <div className="subjects-list">
                    {course.subjects.map((subject, index) => (
                      <span key={index} className="subject-tag">
                        {subject}
                      </span>
                    ))}
                  </div>
                </div>
              )}
              
              {course.isStream && (
                <div className="expand-indicator">
                  {expandedCourse === course.id ? '▲' : '▼'}
                </div>
              )}
            </div>
          </div>
        ))}
      </section>
    </div>
  );
};

export default CoursesPage;